import { render, staticRenderFns } from "./StaffEditPage.vue?vue&type=template&id=2e32e5e9&"
import script from "./StaffEditPage.vue?vue&type=script&lang=ts&"
export * from "./StaffEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports